var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appReady
    ? _c(
        "div",
        { attrs: { id: "app", name: "app" } },
        [
          _c("div", { attrs: { id: "app-top" } }),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c("ribbon"),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: "login-page", "hide-footer": "", lazy: "" } },
            [
              _c(
                "span",
                {
                  attrs: { slot: "modal-title", id: "login-title" },
                  domProps: { textContent: _vm._s(_vm.$t("login.title")) },
                  slot: "modal-title",
                },
                [_vm._v("Sign in")]
              ),
              _vm._v(" "),
              _c("login-form"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              _vm.showAlert && _vm.showAlert.display
                ? _c("Alert", {
                    attrs: {
                      text: _vm.showAlert.text,
                      type: _vm.showAlert.type,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }